/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Forced_TitleInputs */



/**
* | output |
* | --- |
* | "Forced Subtitle" |
*
* @param {Event_Forced_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_forced_title = /** @type {((inputs?: Event_Forced_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Forced_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titre force")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erzwungener Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli forzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принудительные субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulo forzado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("强制字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強制字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनिवार्य उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda forçada")
	return /** @type {LocalizedString} */ ("Forced Subtitle")
});